import createReducer from "./createReducer";
import { SUPPRESS_SUCCESS_GROWL } from "utils/constants";
import { addFiltering } from "./common/Filtering";
import { addColumnFilters } from "./common/ColumnFilters";
import { mergeItem } from "utils/common";
import { CONTENT_FEED_ACTIONS, CONTENT_FEEDS_API_GATEWAY_PREFIX } from "./actions/ContentFeedActions";

const initialState = {
	items: [],
	isLoading: false,
	hasErrorLoading: false,
	totalPages: 0,
	totalItems: 0,
};

const CONTENT_FEEDS_ACTIONS = {
	FETCH_CONTENT_FEEDS_AJAX: "FETCH_CONTENT_FEEDS_AJAX",
	FETCH_CONTENT_FEEDS_SUCCESS: "FETCH_CONTENT_FEEDS_SUCCESS",
	FETCH_CONTENT_FEEDS_ERROR: "FETCH_CONTENT_FEEDS_ERROR",
	FETCH_CONTENT_FEEDS_CANCEL: "FETCH_CONTENT_FEEDS_CANCEL",

	RESET_CONTENT_FEEDS: "RESET_CONTENT_FEEDS",
};

export const handlers = {
	[CONTENT_FEEDS_ACTIONS.FETCH_CONTENT_FEEDS_AJAX]: fetchContentFeeds,
	[CONTENT_FEEDS_ACTIONS.FETCH_CONTENT_FEEDS_SUCCESS]: fetchContentFeedsSuccess,
	[CONTENT_FEEDS_ACTIONS.FETCH_CONTENT_FEEDS_ERROR]: fetchContentFeedsError,

	[CONTENT_FEEDS_ACTIONS.RESET_CONTENT_FEEDS]: resetContentFeeds,

	[CONTENT_FEED_ACTIONS.TOGGLE_AUTO_UPDATES_SUCCESS]: updateContentFeedItem,
};

let reducerConfig = {
	typeRoot: "CONTENT_FEEDS",
	actionTypes: CONTENT_FEEDS_ACTIONS,
	actionCreators: {
		loadContentFeeds,
		clearContentFeeds,
	},
	initialState,
	handlers,
};

reducerConfig = addFiltering(reducerConfig, { sort: "name:asc" });
reducerConfig = addColumnFilters(reducerConfig, {
	format: {
		name: "format",
		type: "Checkbox",
		displayName: "Type",
	},
	autoUpdate: {
		name: "autoUpdate",
		type: "Checkbox",
		displayName: "Auto Updates",
	},
});

export function loadContentFeeds(libraryId) {
	return (dispatch, getState) => {
		let state = getState();
		let { filterInfo } = state.contentFeeds;

		return dispatch({
			type: CONTENT_FEEDS_ACTIONS.FETCH_CONTENT_FEEDS_AJAX,
			meta: SUPPRESS_SUCCESS_GROWL,
			AJAX: {
				params: filterInfo,
				gateway: CONTENT_FEEDS_API_GATEWAY_PREFIX,
				url: `feeds/content/creativeLibrary/${libraryId}`,
				success: CONTENT_FEEDS_ACTIONS.FETCH_CONTENT_FEEDS_SUCCESS,
				error: CONTENT_FEEDS_ACTIONS.FETCH_CONTENT_FEEDS_ERROR,
				cancel: CONTENT_FEEDS_ACTIONS.FETCH_CONTENT_FEEDS_CANCEL,
			},
		});
	};
}

export function clearContentFeeds() {
	return (dispatch) => {
		dispatch({
			type: CONTENT_FEEDS_ACTIONS.RESET_CONTENT_FEEDS,
		});
		return Promise.resolve({ success: true });
	};
}

export function fetchContentFeeds(state, action) {
	return {
		...state,
		items: [],
		isLoading: true,
		hasErrorLoading: false,
	};
}

const API_STATUS_DONE = "done";
const NORMALIZED_STATUS_SUCCESS = "success";
const NORMALIZED_STATUS_ERROR = "error";

function normalizeLastRunStatus(lastRun) {
	if (!lastRun || !lastRun.lastUpdateStatus) {
		return {};
	}

	const isSuccess = lastRun.lastUpdateStatus === API_STATUS_DONE;
	return {
		lastUpdateStatus: isSuccess ? NORMALIZED_STATUS_SUCCESS : NORMALIZED_STATUS_ERROR,
		lastUpdateErrorMessage: lastRun.lastUpdateErrorMessage || null,
	};
}

export function fetchContentFeedsSuccess(state, action) {
	const { data } = action.payload;

	const mappedItems = data.items.map(item => ({
		...item,
		libraryId: item.idCreativeLibrary,
		...normalizeLastRunStatus(item.lastRun),
	}));

	return {
		...state,
		items: mappedItems,
		totalPages: data.totalPages,
		totalItems: data.totalItems,
		isLoading: false,
		hasErrorLoading: false,
	};
}

export function fetchContentFeedsError(state, action) {
	return {
		...state,
		isLoading: false,
		hasErrorLoading: true,
	};
}

function resetContentFeeds(state, action) {
	return {
		...initialState,
		filterInfo: state.filterInfo,
		columnFilters: state.columnFilters,
	};
}

function updateContentFeedItem(state, action) {
	const { feedId, autoUpdate } = action.payload.original;
	const currentItem = state.items.find(item => item.id === feedId);

	if (!currentItem) {
		return state;
	}

	const updatedItem = {
		...currentItem,
		autoUpdate,
	};

	return {
		...state,
		items: mergeItem(state.items, updatedItem),
	};
}

export default createReducer(reducerConfig.initialState, reducerConfig.handlers);
export const ContentFeeds = reducerConfig.actionCreators;

